import axios from 'axios';
const baseUrl = "/api/v1";

export const assessment = {
    delete: (id, params) => axios.delete(`${baseUrl}/assessments/${id}`, { params })
}